module.exports = (__webpack_require__(3))(213);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/ItemView.js from dll-reference girder_lib
// module id = 45
// module chunks = 0